import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
import { del, get, set } from 'idb-keyval'

/** Persisted query cache in IndexedDB (§10 phase 1): lists and notes open instantly, also offline. */
export const persister = createAsyncStoragePersister({
  storage: {
    getItem: (k) => get<string>(k).then((v) => v ?? null),
    setItem: (k, v) => set(k, v),
    removeItem: (k) => del(k),
  },
  key: 'brain.query-cache',
  throttleTime: 1000,
})

export const PERSIST_MAX_AGE = 7 * 24 * 60 * 60 * 1000
/** Bump when cached shapes change incompatibly. */
export const CACHE_BUSTER = 'm1-1'

/** Search results and version payloads are not worth persisting. */
export function shouldPersistQuery(key: readonly unknown[]): boolean {
  return !['search', 'versions', 'passkeys'].includes(String(key[0]))
}
